module.exports = __webpack_public_path__ + "static/img/model2.1a4c0cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-images/model2.png
// module id = MhJv
// module chunks = 0